import React, { FC, useState } from 'react'
import { Typography } from 'react-components'
import { CTAButton, StyledGhostButton } from '../style'
import { FormattedBookingTypeData } from '../../../models/property-details-page/booking-type-model'
import { SearchbarFieldsReturn } from '../hooks/use-searchbar'
import get from 'lodash/get'
import getChildrenAges from '../utils/get-children-ages'
import useDynamicQueryParams from '../hooks/use-dynamic-query-params'
import { pdpPageActions } from '../../../services/analytics-service/actions'
import { pdpPageCategories } from '../../../services/analytics-service/categories'
import AnalyticsService from '../../../services/analytics-service'
import updateDateRetentionCookies from '../utils/update-date-retention-cookies'
import { getSearchDate } from '../../../utils/miscellaneous-utils'
import { useQuery } from '../../../hooks/query'
import { MailPickerIcon } from '../../search-result-listing/header-section/searchbar/widget-styles'
import { useTranslation } from '../../../hooks/locale'

type EnquiryButtonProps = {
    bookingType: FormattedBookingTypeData | null
    searchbar: SearchbarFieldsReturn
    showShortTitle?: boolean
    position: 'gallery' | 'sidebar' | 'sticky_footer' | 'price_widget'
}

const EnquiryButton: FC<EnquiryButtonProps> = props => {
    const { bookingType, searchbar, position, showShortTitle = false } = props
    const query = useQuery()
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const dynamicQueryParams = JSON.parse(get(bookingType, 'subType.dynamicQueryParams', '{}'))
    const childrenAges = getChildrenAges(searchbar.kids)
    const qpValues = { ...query, ...searchbar, childrenAges }
    const url = useDynamicQueryParams(bookingType?.subType, qpValues, dynamicQueryParams)
    const type = get(bookingType, 'subType.type')
    const titleKey = showShortTitle ? 'subType.shortTitle' : 'subType.title'
    const { t } = useTranslation()

    const onEnquiryClick = (event: React.MouseEvent) => {
        setTimeout(() => {
            AnalyticsService.trackEvent({
                category: pdpPageCategories.PDP_PAGE,
                action: pdpPageActions.ENQUIRY_BUTTON_CLICKED,
                label: position,
            })
        }, 0)
        const arrival = getSearchDate(searchbar.arrival)
        const departure = getSearchDate(searchbar.departure)
        const adultsCount = searchbar.adults
        const childrenCount = searchbar.kids
        updateDateRetentionCookies(arrival, departure, adultsCount, childrenCount, searchbar.location)
        if (type === 'redirect') {
            event.preventDefault()
            setIsLoading(true)
            window.open(url, '_blank')
            setIsLoading(false)
        } else {
            setIsLoading(true)
            setTimeout(() => {
                setIsLoading(false)
            }, 5000)
        }
    }

    return (
        <CTAButton onClick={onEnquiryClick}>
            <StyledGhostButton
                isPrimary
                href={url}
                onClick={onEnquiryClick}
                disabled={isLoading ? true : undefined}
                loading={isLoading ? true : undefined}
                buttonSize="large"
            >
                <MailPickerIcon alt={t('mailIconText')} style={{ position: 'unset' }} />
                <Typography variant="subtitle2" fontWeight="semiBold">
                    {get(bookingType, titleKey)}
                </Typography>
            </StyledGhostButton>
        </CTAButton>
    )
}

export default EnquiryButton
